const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

function isLocalhost() {
  if (typeof window === 'undefined') return false;
  const h = window.location && window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h === '0.0.0.0';
}

const CONFIG = {
  production: {
    API_ENDPOINT: 'https://api.miaovpn.com/api',
  },
  development: {
    API_ENDPOINT: 'http://localhost:5000/api',
  },
  staging: {
    API_ENDPOINT: 'https://stg-401.miaovpn.com/api',
  },
};

module.exports = {
  // ENV,
  // API_ENDPOINT: CONFIG[ENV].API_ENDPOINT,
  ENV,
  API_ENDPOINT:
    process.env.REACT_APP_API_ENDPOINT ||
    (isLocalhost()
      ? process.env.REACT_APP_LOCAL_API_ENDPOINT || 'http://localhost:5000/api'
      : CONFIG[ENV].API_ENDPOINT),
};
